(function(angular) {
    'use strict';

    const constants = require('@utils/_constants');
    angular
        .module('enervee')
        .directive('rebateApplicationForm', function () {
            return {
                restrict: 'E',
                scope: {},
                bindToController: true,
                controllerAs: 'vm',
                controller: [
                    '$log',
                    '$q',
                    '$sce',
                    '$timeout',
                    '$window',
                    '$cookies',
                    'AnalyticsService',
                    'EnerveeRebateService',
                    'CartService',
                    'CookiesService',
                    function (
                        $log,
                        $q,
                        $sce,
                        $timeout,
                        $window,
                        $cookies,
                        AnalyticsService,
                        EnerveeRebateService,
                        CartService,
                        CookiesService,
                    ) {
                        this.$onInit = function () {
                            var vm = this;
                            vm.showForm = false;
                            vm.formSrc = "";
                            var acceptableOrigins = [/localhost:\d{1,4}$/, /.*\.enervee\.com$/, /192\.168\.20\.21:\d{1,4}$/];
                            var formDeferred;

                            EnerveeRebateService.registerApplicationForm(openForm);

                            function openForm(formSrc, triggerSrc) {
                                vm.triggerSource = triggerSrc;
                                if (!formSrc) {
                                    $log.error("No iframe src supplied for verification form!");
                                    return;
                                }
                                formSrc = addClaimValidationBypassCode(formSrc);
                                angular.element($window).on('message', onWindowMessage);
                                formDeferred = $q.defer();
                                let segmentAnonUserId = CookiesService.get('segment_anon_user_id');
                                if (segmentAnonUserId !== undefined) {
                                    formSrc += '&suid=' + segmentAnonUserId;
                                }
                                return AnalyticsService.isKnownBotTraffic().then(function (knownBotTraffic) {
                                    formSrc += '&bot=' + knownBotTraffic;
                                    vm.formSrc = $sce.trustAsResourceUrl(formSrc);
                                    vm.showForm = true;
                                    angular.element('body').addClass('modal-open-alt');

                                    /**
                                     * Track that the user started the user validation process.
                                     */
                                    AnalyticsService.reportEvent('User Validation Opened', {
                                        location: 'modal',
                                        source: vm.triggerSource,
                                        cartId: CartService.cartDetails.cartId,
                                    });
                                    return formDeferred.promise;
                                });
                            }

                            /**
                             * Retrieves claim validation bypass code from cookie and append
                             * it to the formSrc url as a query parameter.
                             *
                             * @param {string} formSrc - Form Source url to append bypass code to.
                             * @return {string} Url with claim validation code query param.
                             */
                            function addClaimValidationBypassCode(formSrc) {
                                const CODE_QUERY_PARAM = constants.CLAIM_VALIDATION_BYPASS_CODE;
                                const claimValidationBypassCode = CookiesService.get(CODE_QUERY_PARAM);
                                if (claimValidationBypassCode) {
                                    formSrc += `&${CODE_QUERY_PARAM}=${claimValidationBypassCode}`;
                                }
                                return formSrc;
                            }

                            function onWindowMessage(e) {
                                if (!originIsAcceptable(e.originalEvent.origin)) {
                                    return;
                                }
                                var data = e.originalEvent.data;
                                onFormComplete(data);
                            }

                            function originIsAcceptable(origin) {
                                for (var i = 0; i < acceptableOrigins.length; i++) {
                                    if (acceptableOrigins[i].test(origin)) {
                                        return true;
                                    }
                                }
                                $log.warn('Response from iframe origin "' + origin + '" is not an acceptable origin!');
                                return false;
                            }

                            /**
                             * Gets called once the iframe form is complete
                             *
                             * @param {Object} eventData data from the iframe's postMessage
                             * @return {Promise}
                             */
                            function onFormComplete(eventData) {
                                vm.showForm = false;
                                angular.element($window).off('message', onWindowMessage);
                                angular.element('body').removeClass('modal-open-alt');
                                trackUserValidated(eventData);
                                return formDeferred.resolve(eventData);
                            }

                            /**
                             * Track that the user completed (or cancelled) the user validation process.
                             *
                             * @param {Object} eventData data from the iframe's postMessage
                             */
                            function trackUserValidated(eventData) {
                                var userWasValidated = !!(eventData.data && eventData.data.is_valid);
                                var dismissed = eventData.reason === EnerveeRebateService.formClosedReasons.DISMISS;
                                var data = {
                                    validation_success: userWasValidated,
                                    form_dismissed: dismissed,
                                    location: 'modal',
                                    source: vm.triggerSource,
                                    cartId: CartService.cartDetails.cartId,
                                }
                                if (eventData.location === constants.REPORTING_FORM) {
                                    AnalyticsService.reportEvent('Reporting Questions Closed', data);
                                } else if (eventData.location === constants.VERIFICATION_FORM) {
                                    AnalyticsService.reportEvent('User Validation Closed', data);
                                } else if (eventData.reason === constants.FORM_COMPLETE) {
                                    AnalyticsService.reportEvent('User Validation Completed', data);
                                }
                            }
                        };
                    }
                ],
                template: '<div ng-if="vm.showForm" style="overflow:scroll;-webkit-overflow-scrolling:touch;position:fixed;top:0;bottom:0;left:0;right:0;z-index:2147483647;background-color:rgba(0,0,0,.25);">' +
                          '<iframe id="rrapiApplicationForm" ng-src="{{ vm.formSrc }}" type="text/html" allowTransparency="true" frameborder="0" style="display:block;width:100%;height:100%;border:none;"></iframe>' +
                          '</div>'
            };
        });
})(angular);
